module.exports = __webpack_public_path__ + "static/img/logo.26e1377.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/desktop@1x/logo.svg
// module id = xQJc
// module chunks = 0